import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=cfe79c46&"
import script from "./Calls.vue?vue&type=script&lang=ts&"
export * from "./Calls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports